import React, { useRef, useEffect, useState } from "react";
import ExcelJS from "exceljs";
import { Download, Sheet, FileText } from "lucide-react";
import jsPDF from "jspdf";
import "jspdf-autotable";
import {
  getBankAndBranchLogo,
  getThemeURL,
} from "../../../../../Services/EndPoints";
import { getData, postDataWithBody } from "../../../../../Services/Services";

const ProgressBarChart = ({
  data,
  heightExpandLevel,
  yAxisLabels,
  yAxisKeys,
  colors,
  xAxisKey,
  selectedBankIds,
  selectedBranchIds,
  editConfigIds,
  maxValue = null, // Optional: specify max value for single values
  item = {},
}) => {
  const containerRef = useRef(null);
  const [containerHeight, setContainerHeight] = useState(300);

  // Add these state variables
  const [userProfile, setUserProfile] = useState(null);
  const [logoFromApi, setLogoFromApi] = useState(null);
  const [bankName, setBankName] = useState("");
  const [bankData, setBankData] = useState(null);
  const [shouldShowBankLogo, setShouldShowBankLogo] = useState(false);

  // Add these helper functions before the main return statement
  const getUserProfile = async () => {
    try {
      const profile = await getData(getThemeURL);
      if (profile && profile.length > 0) {
        setUserProfile(profile[0]);
        // After getting profile, fetch logo with proper payload
        if (item.showBankLogo) {
          fetchLogoAndNameFromApi(profile[0]);
        }
      }
    } catch (error) {
      console.error("Error fetching user profile:", error);
      setUserProfile(null);
    }
  };

  const createPayload = (profile) => {
    let admin_role = "U"; // default value

    if (profile.is_admin === true) {
      admin_role = "HO";
    } else if (profile.role_name === "SUPER ADMIN") {
      admin_role = "SA";
    }

    return {
      admin_role: admin_role,
      bank_id: profile.bank_id || null,
      branch_id: profile.branch_id || null,
    };
  };

  const byteArrayToImageUrl = (byteArray) => {
    try {
      const uint8Array = new Uint8Array(byteArray);
      const blob = new Blob([uint8Array], { type: "image/png" });
      const imageUrl = URL.createObjectURL(blob);
      return imageUrl;
    } catch (error) {
      console.error("Error converting byte array to image:", error);
      return null;
    }
  };

      // Replace the checkSingleBankData function with this updated version
    const checkSingleBankData = () => {
      const dataToCheck = data || [];
      if (!dataToCheck || dataToCheck.length === 0) return false;
    
      // PRIORITY 1: Use selectedBranchIds if available and single
      if (selectedBranchIds && selectedBranchIds.length === 1) {
        return true;
      }
    
      // PRIORITY 2: Use selectedBankIds if available and single
      if (selectedBankIds && selectedBankIds.length === 1) {
        return true;
      }
    
      // PRIORITY 3: Use editConfigIds as fallback if available and single
      if (editConfigIds && editConfigIds.length === 1) {
        return true;
      }
    
      // Extract unique bank IDs from the chart data as final fallback
      const bankIds = new Set();
    
      dataToCheck.forEach((row) => {
        // Check common bank ID field names
        const bankId = row.bank_id || row.bankId || row.Bank_ID;
        if (bankId) {
          bankIds.add(bankId);
        }
      });
    
      console.log("Bank IDs in chart data:", Array.from(bankIds));
    
      // Show logo if there's exactly one bank in the data
      return bankIds.size === 1;
    };
      const fetchLogoAndNameFromApi = async (profile) => {
      try {
        const payload = createPayload(profile);
        const response = await postDataWithBody(
          getBankAndBranchLogo,
          payload,
          {}
        );
    
        if (Array.isArray(response) && response.length > 0) {
          console.log(response, "logooooooooo3");
          let bankData = null;
    
          // Determine which bank data to use based on user role and chart data
          if (profile.role_name === "SUPER ADMIN" || profile.is_admin === true) {
            console.log(response, "logoooooooooo2");
            const shouldShowLogo = checkSingleBankData();
    
            if (shouldShowLogo) {
              console.log(response, "logoooooooooo1");
    
              // PRIORITY 1: Use selectedBranchIds if available and single
              if (selectedBranchIds && selectedBranchIds.length === 1) {
                const branchId = selectedBranchIds[0];
                console.log("Using single selectedBranchIds:", branchId);
    
                // Search through all banks and their branches
                for (const bank of response) {
                  if (bank.branches && Array.isArray(bank.branches)) {
                    const matchingBranch = bank.branches.find(
                      (branch) =>
                        branch.id == branchId ||
                        branch.branch_id == branchId ||
                        branch.Branch_ID == branchId
                    );
    
                    if (matchingBranch) {
                      // Found the branch, use branch data
                      bankData = {
                        ...bank,
                        ...matchingBranch,
                        isBranch: true,
                      };
                      break;
                    }
                  }
                }
              }
              // PRIORITY 2: Use selectedBankIds if available and single
              else if (selectedBankIds && selectedBankIds.length === 1) {
                const bankId = selectedBankIds[0];
                console.log("Using single selectedBankIds:", bankId);
    
                bankData = response.find(
                  (bank) =>
                    bank.id == bankId ||
                    bank.bank_id == bankId ||
                    bank.Bank_ID == bankId
                );
              }
              // PRIORITY 3: Use editConfigIds as fallback if available and single
              else if (editConfigIds && editConfigIds.length === 1) {
                const configId = editConfigIds[0];
                console.log("Using single editConfigIds as fallback:", configId);
    
                // Try to find bank/branch by config ID
                bankData = response.find(
                  (bank) =>
                    bank.id == configId ||
                    bank.bank_id == configId ||
                    bank.Bank_ID == configId ||
                    (bank.branches && bank.branches.some(
                      branch => branch.id == configId || branch.branch_id == configId
                    ))
                );
    
                // If we found a bank but need branch-specific data
                if (bankData && bankData.branches) {
                  const matchingBranch = bankData.branches.find(
                    branch => branch.id == configId || branch.branch_id == configId
                  );
                  if (matchingBranch) {
                    bankData = {
                      ...bankData,
                      ...matchingBranch,
                      isBranch: true,
                    };
                  }
                }
              }
              // PRIORITY 4: Fallback to bank_id from chart data
              else {
                const dataToCheck =  data || [];
                const tableIdToMatch = dataToCheck[0]?.bank_id || dataToCheck[0]?.bankId || dataToCheck[0]?.Bank_ID;
                console.log("Using bank_id as final fallback:", tableIdToMatch);
    
                if (tableIdToMatch) {
                  bankData = response.find(
                    (bank) =>
                      bank.id == tableIdToMatch ||
                      bank.bank_id == tableIdToMatch ||
                      bank.Bank_ID == tableIdToMatch
                  );
                }
              }
    
              console.log(bankData, "bankDataaaaaaaaa");
    
              // If no match found, use first available bank data
              if (!bankData && response.length > 0) {
                bankData = response[0];
              }
            } else {
              // Multiple banks or branches in selection, don't show logo
              setShouldShowBankLogo(false);
              return;
            }
          } else {
            // For non-Super Admin users, use the first response (their bank)
            bankData = response[0];
          }
    
          if (!bankData) {
            setShouldShowBankLogo(false);
            return;
          }
    
          setBankData(bankData);
          setShouldShowBankLogo(true);
    
          // Set bank/branch name
          if (bankData.branchName) {
            setBankName(bankData.branchName);
          } else if (bankData.bankName) {
            setBankName(bankData.bankName);
          } else {
            setBankName("");
          }
    
          // Check if image field exists and is an array with data
          // Priority: branch image -> bank image
          if (
            bankData.hasOwnProperty("image") &&
            Array.isArray(bankData.image) &&
            bankData.image.length > 0
          ) {
            const imageUrl = byteArrayToImageUrl(bankData.image);
            setLogoFromApi(imageUrl);
          } else if (
            bankData.bankLogo &&
            Array.isArray(bankData.bankLogo) &&
            bankData.bankLogo.length > 0
          ) {
            // Fallback to bank logo if branch logo not available
            const imageUrl = byteArrayToImageUrl(bankData.bankLogo);
            setLogoFromApi(imageUrl);
          } else {
            setLogoFromApi(null);
          }
        } else {
          setShouldShowBankLogo(false);
        }
      } catch (error) {
        console.error("Error fetching logo and bank name from API:", error);
        setLogoFromApi(null);
        setShouldShowBankLogo(false);
      }
    };
    
    // Update the other useEffect that depends on data changes
    useEffect(() => {
      if (
        item.showBankLogo &&
        userProfile &&
        userProfile.role_name === "SUPER ADMIN"
      ) {
        // Re-check if we should show logo when chart data changes
        const hasSingleBank = checkSingleBankData();
        setShouldShowBankLogo(hasSingleBank);
    
        if (hasSingleBank && bankData) {
          // Re-fetch logo for the specific bank if needed
          fetchLogoAndNameFromApi(userProfile);
        }
      }
    }, [ data, userProfile, selectedBankIds, selectedBranchIds, editConfigIds]); // Add all relevant dependencies
      useEffect(() => {
        if (item.showBankLogo) {
          getUserProfile();
        }
      }, [item.showBankLogo]);
    
      // Update the other useEffect that depends on data changes
    useEffect(() => {
      if (
        item.showBankLogo &&
        userProfile &&
        userProfile.role_name === "SUPER ADMIN"
      ) {
        // Re-check if we should show logo when chart data changes
        const hasSingleBank = checkSingleBankData();
        setShouldShowBankLogo(hasSingleBank);
    
        if (hasSingleBank && bankData) {
          // Re-fetch logo for the specific bank if needed
          fetchLogoAndNameFromApi(userProfile);
        }
      }
    }, [ data, userProfile, selectedBankIds, selectedBranchIds, editConfigIds]); // Add all relevant dependencies
      // Cleanup effect for object URLs
      useEffect(() => {
        return () => {
          if (logoFromApi) {
            URL.revokeObjectURL(logoFromApi);
          }
        };
      }, [logoFromApi]);
    
      // Add useEffect to re-check bank data when tableData changes
      useEffect(() => {
        if (
          item.showBankLogo &&
          userProfile &&
          userProfile.role_name === "SUPER ADMIN"
        ) {
          // Re-check if we should show logo when table data changes
          const hasSingleBank = checkSingleBankData();
          console.log("Re-checking bank data:", { hasSingleBank });
    
          if (hasSingleBank) {
            // Re-fetch logo for the specific bank if needed
            fetchLogoAndNameFromApi(userProfile);
          } else {
            setShouldShowBankLogo(false);
          }
        }
      }, [, data, item.showBankLogo]); // Only depend on length to avoid infinite loops
    // Function to calculate the required Y-axis width based on data values
  const formatHeaderText = (text) => {
    if (!text || typeof text !== "string") return text;

    return text
      .replace(/_/g, " ")
      .split(" ")
      .map((word) => word.charAt(0).toUpperCase() + word.slice(1).toLowerCase())
      .join(" ");
  };

  const downloadExcel = async () => {
    const workbook = new ExcelJS.Workbook();
    const worksheet = workbook.addWorksheet("Chart Data");

    let currentRow = 1;

    // Add bank logo and name if enabled
    if (item.showBankLogo) {
      try {
        // Add logo if available
        if (logoFromApi) {
          const response = await fetch(logoFromApi);
          const arrayBuffer = await response.arrayBuffer();

          const imageId = workbook.addImage({
            buffer: arrayBuffer,
            extension: "png",
          });

          worksheet.addImage(imageId, {
            tl: { col: 0, row: 0 },
            ext: { width: 100, height: 100 },
          });
        }

        // Add bank name if available (whether logo exists or not)
        if (bankName) {
          const bankNameCell = worksheet.getCell(logoFromApi ? "B1" : "A1");
          bankNameCell.value = bankName;
          bankNameCell.font = {
            bold: true,
            size: parseInt(
              bankData?.banknameFontsize || bankData?.branchNameFontsize || 16
            ),
          };
          bankNameCell.alignment = { vertical: "middle", horizontal: "left" };
        }

        // Set row height and spacing
        if (logoFromApi || bankName) {
          worksheet.getRow(1).height = 75;
          worksheet.getRow(2).height = 25;
          currentRow = 4;
        }
      } catch (error) {
        console.error("Error adding logo/name to Excel:", error);
        currentRow = 1;
      }
    }

    // Add title row if pdfChartTitle is available
    const titleText =
      item.pdfChartTitle !== undefined &&
      item.pdfChartTitle !== null &&
      item.pdfChartTitle.trim() !== ""
        ? item.pdfChartTitle.trim()
        : "";

    if (titleText) {
      worksheet.getCell(`A${currentRow}`).value = titleText;

      const titleRow = worksheet.getRow(currentRow);
      titleRow.font = { bold: true, size: 16 };
      titleRow.alignment = { horizontal: "center" };

      const totalColumns = yAxisKeys.length > 1 ? 3 : 2;
      worksheet.mergeCells(
        `A${currentRow}`,
        `${String.fromCharCode(64 + totalColumns)}${currentRow}`
      );

      currentRow += 2;
    }

    // Prepare header row
    const headerRow = [formatHeaderText(xAxisKey)];

    if (yAxisKeys.length > 1 && yAxisKeys[1]) {
      headerRow.push(formatHeaderText(yAxisLabels?.[0] || yAxisKeys[0]));
      headerRow.push(formatHeaderText(yAxisLabels?.[1] || yAxisKeys[1]));
    } else {
      headerRow.push(formatHeaderText(yAxisLabels?.[0] || yAxisKeys[0]));
    }

    worksheet.addRow(headerRow);

    const headerRowIndex = currentRow;
    currentRow++;

    const headerRowObj = worksheet.getRow(headerRowIndex);
    headerRowObj.font = { bold: true };
    headerRowObj.fill = {
      type: "pattern",
      pattern: "solid",
      fgColor: { argb: "FFE0E0E0" },
    };

    // Prepare data rows
    if (!processedData || processedData.length === 0) {
      const naRow = new Array(headerRow.length).fill("NA");
      worksheet.addRow(naRow);
    } else {
      processedData.forEach((rowObj) => {
        const rowArr = [rowObj[xAxisKey]];

        if (yAxisKeys.length > 1 && yAxisKeys[1]) {
          rowArr.push(rowObj.processedFirstValue ?? "NA");
          rowArr.push(rowObj.processedSecondValue ?? "NA");
        } else {
          rowArr.push(rowObj.processedFirstValue ?? "NA");
        }

        worksheet.addRow(rowArr);
      });
    }

    worksheet.columns.forEach((column) => {
      column.width = 15;
    });

    const buffer = await workbook.xlsx.writeBuffer();
    const blob = new Blob([buffer], {
      type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
    });
    const url = URL.createObjectURL(blob);
    const a = document.createElement("a");
    a.href = url;

    const now = new Date();
    const istDate = now.toISOString().split("T")[0].replace(/-/g, "");
    const hours = now.getHours().toString().padStart(2, "0");
    const minutes = now.getMinutes().toString().padStart(2, "0");
    const seconds = now.getSeconds().toString().padStart(2, "0");
    const istTime = `${hours}${minutes}${seconds}`;
    const fileTimestamp = `${istDate}_${istTime}`;
    const fileTitle = (item.title || "chartdata")
      .replace(/\s+/g, "_")
      .toLowerCase();
    const filename = `${fileTitle}_${fileTimestamp}.xlsx`;

    a.download = filename;
    document.body.appendChild(a);
    a.click();
    document.body.removeChild(a);
    URL.revokeObjectURL(url);
  };

  const downloadPDF = async () => {
    try {
      const doc = new jsPDF("landscape", "pt", "a4");
      let currentY = 50;

      let fontName = "Helvetica";
      doc.setFont(fontName);
      doc.setFontSize(13);

      const pdfChartTitle =
        item.pdfChartTitle !== undefined &&
        item.pdfChartTitle !== null &&
        item.pdfChartTitle.trim() !== ""
          ? item.pdfChartTitle.trim()
          : "";

      // Add bank logo and name if enabled
      if (item.showBankLogo && (logoFromApi || bankName)) {
        try {
          const pageWidth = doc.internal.pageSize.width;
          const centerX = pageWidth / 2;

          if (logoFromApi && bankName) {
            // Both logo and name exist - show side by side
            const canvas = document.createElement("canvas");
            const ctx = canvas.getContext("2d");
            const img = new Image();
            img.crossOrigin = "anonymous";

            await new Promise((resolve, reject) => {
              img.onload = () => {
                canvas.width = img.width;
                canvas.height = img.height;
                ctx.drawImage(img, 0, 0);
                resolve();
              };
              img.onerror = reject;
              img.src = logoFromApi;
            });

            const logoDataURL = canvas.toDataURL("image/png");
            const logoWidth = 70;
            const logoHeight = 70;

            doc.setFontSize(16);
            doc.setFont(fontName, "bold");
            const bankNameFontSize =
              bankData?.banknameFontsize || bankData?.branchNameFontsize || 16;
            doc.setFontSize(parseInt(bankNameFontSize));

            const textWidth = doc.getTextWidth(bankName);
            const spacing = 15;
            const totalWidth = logoWidth + spacing + textWidth;
            const startX = centerX - totalWidth / 2;

            const logoX = startX;
            const logoY = currentY;
            const textX = startX + logoWidth + spacing;
            const textY = currentY + logoHeight / 2 + 6;

            doc.addImage(
              logoDataURL,
              "PNG",
              logoX,
              logoY,
              logoWidth,
              logoHeight
            );
            doc.text(bankName, textX, textY);

            currentY += Math.max(logoHeight, 40) + 20;
          } else if (bankName) {
            // Only bank name exists - show centered
            doc.setFont(fontName, "bold");
            const bankNameFontSize =
              bankData?.banknameFontsize || bankData?.branchNameFontsize || 16;
            doc.setFontSize(parseInt(bankNameFontSize));
            doc.text(bankName, centerX, currentY, { align: "center" });
            currentY += 40;
          }

          doc.setFont(fontName, "normal");
          doc.setFontSize(13);
        } catch (error) {
          console.error("Error adding logo/name to PDF:", error);
        }
      }

      // Add title
      const pageWidth = doc.internal.pageSize.width;
      doc.text(pdfChartTitle, pageWidth / 2, currentY, { align: "center" });
      currentY += 30;

      // Prepare headers and data rows
      const headers = [formatHeaderText(xAxisKey)];

      if (yAxisKeys.length > 1 && yAxisKeys[1]) {
        headers.push(formatHeaderText(yAxisLabels?.[0] || yAxisKeys[0]));
        headers.push(formatHeaderText(yAxisLabels?.[1] || yAxisKeys[1]));
      } else {
        headers.push(formatHeaderText(yAxisLabels?.[0] || yAxisKeys[0]));
      }

      const dataRows = processedData.map((row) => {
        const rowArr = [row[xAxisKey]];

        if (yAxisKeys.length > 1 && yAxisKeys[1]) {
          rowArr.push((row.processedFirstValue ?? "NA").toString());
          rowArr.push((row.processedSecondValue ?? "NA").toString());
        } else {
          rowArr.push((row.processedFirstValue ?? "NA").toString());
        }

        return rowArr;
      });

      doc.autoTable({
        head: [headers],
        body: dataRows,
        startY: currentY,
        theme: "grid",
        headStyles: { fillColor: [59, 130, 246] },
        styles: { fontSize: 10, halign: "center" },
        margin: { left: 40, right: 40 },
        columnStyles: {
          0: {
            halign: (data) => {
              const cellValue = data.cell.raw;
              if (!isNaN(cellValue) && !isNaN(parseFloat(cellValue))) {
                return "center";
              } else {
                return "left";
              }
            },
          },
        },
      });

      // ADD FOOTER SECTION
      const pageHeight = doc.internal.pageSize.height;
      let footerY = pageHeight - 180;

      doc.setFontSize(10);
      doc.text("Letter No.: ", 50, footerY + 100);
      doc.text("Date: ", 50, footerY + 120);
      doc.text("Copy: ", 50, footerY + 140);
      doc.text("XXXX/ ", 550, footerY + 100);
      doc.text("XX(XXXX)(XXXX)/", 550, footerY + 120);
      doc.text("XXXX(XX)/", 550, footerY + 140);

      doc.setFont(fontName, "bold");
      doc.text("[ ]", 550, footerY + 160);
      doc.setFont(fontName, "normal");

      const now = new Date();
      const istDate = now.toISOString().split("T")[0].replace(/-/g, "");
      const hours = now.getHours().toString().padStart(2, "0");
      const minutes = now.getMinutes().toString().padStart(2, "0");
      const seconds = now.getSeconds().toString().padStart(2, "0");
      const istTime = `${hours}${minutes}${seconds}`;
      const fileTimestamp = `${istDate}_${istTime}`;
      const fileTitle = (item.title || "chart_report")
        .replace(/\s+/g, "_")
        .toLowerCase();
      const filename = `${fileTitle}_${fileTimestamp}.pdf`;

      doc.save(filename);
    } catch (error) {
      alert("Error generating PDF. Please try again.");
      console.error("PDF generation error:", error);
    }
  };

  // useEffect to fetch profile data
  useEffect(() => {
    if (item.showBankLogo) {
      getUserProfile();
    }
  }, [item.showBankLogo]);

  // Cleanup effect for object URLs
  useEffect(() => {
    return () => {
      if (logoFromApi) {
        URL.revokeObjectURL(logoFromApi);
      }
    };
  }, [logoFromApi]);

  useEffect(() => {
    const updateDimensions = () => {
      if (containerRef.current) {
        const rect = containerRef.current.getBoundingClientRect();
        setContainerHeight(Math.max(200, rect.height - 80));
      }
    };

    updateDimensions();

    const resizeObserver = new ResizeObserver(updateDimensions);
    if (containerRef.current) {
      resizeObserver.observe(containerRef.current);
    }

    return () => {
      if (containerRef.current) {
        resizeObserver.unobserve(containerRef.current);
      }
    };
  }, []);

  // Process data to handle single value comparison against the highest value
  const processedData = React.useMemo(() => {
    if (!data || data.length === 0) return [];

    const yKey = yAxisKeys?.[0];
    const hasSecondKey = yAxisKeys.length > 1 && yAxisKeys[1];

    if (!hasSecondKey) {
      // Single value case - use highest value as baseline, don't sum remaining
      const maxValueItem = data.reduce((max, item) => {
        const currentValue = item[yKey] || 0;
        const maxCurrentValue = max[yKey] || 0;
        return currentValue > maxCurrentValue ? item : max;
      }, data[0]);

      // Get the highest value as baseline
      const baselineValue = maxValueItem[yKey] || 0;

      // Filter out the highest value item
      const filteredData = data.filter((item) => item !== maxValueItem);

      if (filteredData.length === 0) return [];

      return filteredData.map((entry) => {
        const firstValue = entry[yKey] || 0;
        // Calculate percentage using the highest value as baseline (not sum of remaining)
        const percentage =
          baselineValue > 0 ? (firstValue / baselineValue) * 100 : 0;

        return {
          ...entry,
          processedFirstValue: firstValue,
          processedSecondValue: baselineValue - firstValue,
          firstPercentage: percentage,
          secondPercentage: Math.max(0, 100 - percentage),
          total: baselineValue,
          isSingleValue: true,
          maxValueInDataset: baselineValue,
        };
      });
    } else {
      // Two value case - use actual values (no change from original logic)
      return data.map((entry) => {
        const firstValue = entry[yKey] || 0;
        const secondValue = entry[yAxisKeys[1]] || 0;
        const total = firstValue + secondValue;
        const firstPercentage = total > 0 ? (firstValue / total) * 100 : 0;
        const secondPercentage = total > 0 ? (secondValue / total) * 100 : 0;

        return {
          ...entry,
          processedFirstValue: firstValue,
          processedSecondValue: secondValue,
          firstPercentage,
          secondPercentage,
          total,
          isSingleValue: false,
          displayText: `${firstValue}/${secondValue}`,
        };
      });
    }
  }, [data, yAxisKeys, maxValue]);

  // Get the maximum value for header display
  const maxValueForDisplay = React.useMemo(() => {
    if (processedData.length === 0) return 100;
    if (yAxisKeys.length > 1 && yAxisKeys[1]) return "Variable"; // For dual values
    return processedData[0]?.maxValueInDataset || 100;
  }, [processedData, yAxisKeys]);

  // Handle case where no data remains after filtering
  if (processedData.length === 0) {
    return (
      <div
        ref={containerRef}
        style={{
          width: "100%",
          height: "100%",
          minHeight: "200px",
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          padding: "16px",
          boxSizing: "border-box",
        }}
      >
        <div
          style={{
            fontSize: "16px",
            color: "#666",
            textAlign: "center",
          }}
        >
          No data to display
        </div>
      </div>
    );
  }

  const legendFontSize = item?.legendFontSize || 8;
  return (
    <div
      ref={containerRef}
      style={{
        width: "100%",
        height: "100%",
        minHeight: "200px",
        overflowY: "auto",
        overflowX: "hidden",
        padding: "16px",
        boxSizing: "border-box",
      }}
    >
      {/* Download Buttons */}
      {(item.showDownloadExcelChart || item.showDownloadPDFChart) && (
        <div
          style={{
            display: "flex",
            justifyContent: "flex-end",
            marginBottom: 10,
            gap: "10px",
          }}
        >
          {item.showDownloadExcelChart && (
            <button
              onClick={downloadExcel}
              style={{
                padding: "6px 6px",
                backgroundColor: "#10B981",
                color: "white",
                border: "none",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              <Download size={16} />
              <Sheet size={16} />
            </button>
          )}
          {item.showDownloadPDFChart && (
            <button
              onClick={downloadPDF}
              style={{
                padding: "6px 6px",
                backgroundColor: "#EF4444",
                color: "white",
                border: "none",
                borderRadius: "6px",
                display: "flex",
                alignItems: "center",
                gap: "8px",
                fontWeight: 500,
                cursor: "pointer",
              }}
            >
              <Download size={16} />
              <FileText size={16} />
            </button>
          )}
        </div>
      )}

      {/* Y-Axis Labels on Top */}
      <div
        style={{
          display: "flex",
          justifyContent: "center",
          marginBottom: "20px",
          fontSize: "16px",
          fontWeight: "600",
          color: "#374151",
          paddingBottom: "12px",
          borderBottom: "1px solid #e5e7eb",
          position: "sticky",
          top: "0",
          backgroundColor: "white",
          zIndex: 10,
          fontSize: `${legendFontSize}px`,
        }}
      >
        <span
          style={{
            display: "flex",
            alignItems: "center",
            gap: "12px",
          }}
        >
          <div
            style={{
              width: "16px",
              height: "16px",
              backgroundColor: colors[0] || "#10b981",
              borderRadius: "3px",
            }}
          ></div>
          <span style={{ fontSize: `${legendFontSize}px` }}>
            {yAxisLabels?.[0] || yAxisKeys[0]}
          </span>
          {yAxisKeys.length > 1 && yAxisKeys[1] ? (
            <>
              <span
                style={{ margin: "0 12px", color: "#6b7280", fontSize: "14px" }}
              >
                vs
              </span>
              <div
                style={{
                  width: "16px",
                  height: "16px",
                  backgroundColor: colors[1] || "#ef4444",
                  borderRadius: "3px",
                }}
              ></div>
              <span style={{ fontSize: `${legendFontSize}px` }}>
                {yAxisLabels?.[1] || yAxisKeys[1]}
              </span>
            </>
          ) : (
            <></>
          )}
        </span>
      </div>

      {/* Scrollable Progress Bars Container */}
      <div
        style={{
          height: `${containerHeight - 80}px`,
          overflowY: "auto",
          overflowX: "hidden",
          paddingRight: "8px",
        }}
      >
        {processedData.map((entry, index) => {
          const {
            processedFirstValue,
            processedSecondValue,
            firstPercentage,
            secondPercentage,
            isSingleValue,
          } = entry;

          // Calculate dynamic bar height based on available space and number of items
          const availableHeight = containerHeight - 120;
          const itemSpacing = 16;
          const labelHeight = 32;
          const totalSpacing = (processedData.length - 1) * itemSpacing;
          const maxBarHeight = Math.max(
            24,
            (availableHeight -
              totalSpacing -
              processedData.length * labelHeight) /
              processedData.length
          );
          const barHeight = Math.min(48, Math.max(24, maxBarHeight));

          return (
            <div
              key={index}
              style={{
                marginBottom: "16px",
                width: "100%",
                boxSizing: "border-box",
              }}
            >
              {/* Branch Label and Values */}
              <div
                style={{
                  display: "flex",
                  justifyContent: "space-between",
                  alignItems: "center",
                  marginBottom: "8px",
                  fontSize: "14px",
                  fontWeight: "500",
                  color: "#111827",
                  height: "24px",
                }}
              >
                <span
                  style={{
                    whiteSpace: "nowrap",
                    overflow: "hidden",
                    textOverflow: "ellipsis",
                    maxWidth: "60%",
                  }}
                >
                  {entry[xAxisKey]}
                </span>
                <span
                  style={{
                    fontSize: "12px",
                    color: "#6b7280",
                    whiteSpace: "nowrap",
                    display: "flex",
                    alignItems: "center",
                    gap: "8px",
                  }}
                >
                  {/* Only show the displayText for dual values, show percentage badge for single values */}
                  {!isSingleValue && <span>{entry.displayText}</span>}
                  {isSingleValue && (
                    <span
                      style={{
                        backgroundColor: colors[0] || "#10b981",
                        color: "white",
                        padding: "2px 6px",
                        borderRadius: "4px",
                        fontSize: "10px",
                        fontWeight: "600",
                      }}
                    >
                      {Math.round(firstPercentage)}%
                    </span>
                  )}
                </span>
              </div>

              {/* Progress Bar Container */}
              <div
                style={{
                  backgroundColor: "#e5e7eb",
                  borderRadius: "8px",
                  height: `${barHeight}px`,
                  position: "relative",
                  overflow: "hidden",
                  width: "100%",
                  display: "flex",
                }}
              >
                {/* First portion (primary value) */}
                <div
                  style={{
                    width: `${firstPercentage}%`,
                    height: "100%",
                    backgroundColor: colors[0] || "#10b981",
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    transition: "width 0.8s ease-in-out",
                    borderRadius:
                      firstPercentage === 100 ? "8px" : "8px 0 0 8px",
                  }}
                >
                  {/* Value Label */}
                  {firstPercentage > 15 && (
                    <span
                      style={{
                        color: "white",
                        fontSize: barHeight > 30 ? "12px" : "10px",
                        fontWeight: "600",
                        textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                        whiteSpace: "nowrap",
                      }}
                    >
                      {processedFirstValue}
                    </span>
                  )}
                </div>

                {/* Second portion (secondary value or remaining) - hidden for single value normalized case */}
                {secondPercentage > 0 && !isSingleValue && (
                  <div
                    style={{
                      width: `${secondPercentage}%`,
                      height: "100%",
                      backgroundColor: colors[1] || "#ef4444",
                      display: "flex",
                      alignItems: "center",
                      justifyContent: "center",
                      transition: "width 0.8s ease-in-out",
                      borderRadius:
                        secondPercentage === 100 ? "8px" : "0 8px 8px 0",
                    }}
                  >
                    {/* Second Value Label */}
                    {secondPercentage > 15 && (
                      <span
                        style={{
                          color: "white",
                          fontSize: barHeight > 30 ? "12px" : "10px",
                          fontWeight: "600",
                          textShadow: "0 1px 2px rgba(0,0,0,0.3)",
                          whiteSpace: "nowrap",
                        }}
                      >
                        {processedSecondValue}
                      </span>
                    )}
                  </div>
                )}
              </div>
            </div>
          );
        })}
      </div>
    </div>
  );
};

export default ProgressBarChart;
